// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-table tr td,.error-table tr th{padding:10px 5px}.error-table tr td{border-bottom:1px solid #eee}.error-table tr th{border-bottom:3px solid #eee}.error-table tr th.message{min-width:350px}.error-table tr th.status,.error-table tr th.date,.error-table tr th.type{min-width:200px}.error-table tr th.route{min-width:500px}", ""]);
// Exports
module.exports = exports;
